import React from 'react'
import {cn} from '@utilities/helpers'

export interface ContainerProps {
    className?: string
    children: React.ReactNode
    fullWidth?: boolean
    fullHeight?: boolean
}

export const Container = ({children, className, fullWidth, fullHeight}: ContainerProps) => (
    <div
        className={cn(
            'w-full h-auto px-4 lg:px-8 mx-auto',
            fullWidth ? 'max-w-full' : 'max-w-7xl',
            fullHeight ? 'h-full' : 'h-auto',
            className
        )}
    >
        {children}
    </div>
)

Container.displayName = 'Container'
